import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { PaymentCardService } from '../../finanzas/paymentcard/paymentcard.service';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { InvestmentFinancialDepositsModel, InvestmentFinancialModel } from './investment-financial.model';
import { InvestmentFinancialListComponent } from './investment-financial-list.component';
import { InvestmentFinancialService } from './investment-financial.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-investmentfinancialpay',
    templateUrl: './investment-financial-dialog-pay.component.html',
    styleUrls: ['./investment-financial.component.css'],
    standalone: false
})
export class InvestmentFinancialDialogPayComponent implements OnInit {

  public investmentFinancial: InvestmentFinancialModel = this.data.investment;
  public investmentDeposit: InvestmentFinancialDepositsModel = new InvestmentFinancialDepositsModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public paided: boolean = false;

  public isEditMode: boolean = false;

  public remaining: number = 0;

  public list: boolean = false;

  public billMethods = [
    consts.TYPEPAY_CASH,
    consts.TYPEPAY_CREDITCARD_PAY,
    consts.TYPEPAY_BANKTRANSFERENCE,
    consts.TYPE_SOCIO,
    consts.TYPE_POLIZACREDITO,
    consts.TYPE_DEBITCARD
  ];

  public get billMethodsOptions(): Option[] {
    return this.billMethods.map(method => ({ label: method, value: method }));
  }

  public bankAccounts: BankAccountModel[] = [];
  public paymentCards: PaymentCardModel[] = [];

  public dataSource: InvestmentFinancialDepositsModel[] = [];
  public headerTable: any[] = [
    { field: 'depositDate', title: 'Fecha', cell: (row) => `${new Date(row.depositDate).toLocaleDateString()}`, class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => `${row.amount}  `, class: (row) => `` },
    { field: 'typePay', title: 'Método de pago', cell: (row) => row.typePay ? `${row.typePay}` : '', class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidAmount: boolean = false;
  public invalidTypePay: boolean = false;
  public invalidBankAccount: boolean = false;
  public invalidPaymentCard: boolean = false;

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];
  public polizaCreditoList: PolizaCredito[] = [];

  constructor(
    public dialogRef: MatDialogRef<InvestmentFinancialListComponent>,
    public investmentFinancialService: InvestmentFinancialService,
    public bankAccountService: BankAccountService,
    public paymentCardService: PaymentCardService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private polizaCreditoService: PolizaCreditoService,
  ) { }

  public ngOnInit(): void {

    this.polizaCreditoService.listPayments()
      .then(polizaCredito => {
        this.polizaCreditoList = polizaCredito
      });

    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      });

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.paymentCardService.getList()
          .then(paymentCards => {
            this.paymentCards = paymentCards.list;
            this.ready = true;
          });
      });

    this.getData();
  }

  public pay(): void {
    // Asignamos el uid de la inversion al deposito
    this.investmentDeposit.investmentsFinancialId = this.investmentFinancial.uid;

    let noError: boolean = true;

    // Validations
    if (this.investmentDeposit.depositDate == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.investmentDeposit.amount == null || this.investmentDeposit.amount == 0) {
      noError = false;
      this.invalidAmount = true;
    }

    if (this.investmentDeposit.typePay == null || this.billMethods.includes(this.investmentDeposit.typePay) === false) {
      noError = false;
      this.invalidTypePay = true;
    }

    if (this.investmentDeposit.typePay === consts.TYPEPAY_BANKTRANSFERENCE) {

      if (
        this.investmentDeposit.bankAccountsUid == null ||
        this.investmentDeposit.bankAccountsUid == "" ||
        this.investmentDeposit.bankAccountsUid == consts.EMPTY_GUID
      ) {
        noError = false;
        this.invalidBankAccount = true;
      }

    }

    if (this.investmentDeposit.typePay === consts.TYPEPAY_CREDITCARD_PAY) {

      if (
        this.investmentDeposit.paymentCardsUid == null ||
        this.investmentDeposit.paymentCardsUid == "" ||
        this.investmentDeposit.paymentCardsUid == consts.EMPTY_GUID
      ) {
        noError = false;
        this.invalidPaymentCard = true;
      }

    }

    if (this.investmentDeposit.amount > this.remaining) {
      noError = false;
      this.displayInfo("No puedes ingresar un monto superior al restante");
      return;
    }

    // Controls
    if (this.investmentDeposit.typePay === consts.TYPEPAY_BANKTRANSFERENCE || this.investmentDeposit.typePay === consts.TYPEPAY_CASH) {
      this.investmentDeposit.paymentCardsUid = consts.EMPTY_GUID;
    }

    if (this.investmentDeposit.typePay === consts.TYPEPAY_CREDITCARD_PAY || this.investmentDeposit.typePay === consts.TYPEPAY_CASH) {
      this.investmentDeposit.commissions = 0;
    }

    if (this.investmentDeposit.typePay === consts.TYPEPAY_CASH) {
      this.investmentDeposit.commissions = 0;
      this.investmentDeposit.paymentCardsUid = consts.EMPTY_GUID;
      this.investmentDeposit.bankAccountsUid = consts.EMPTY_GUID;
    }

    if (this.investmentDeposit.typePay !== consts.TYPEPAY_CASH) {
      this.investmentDeposit.efectivoId = null;
    }

    if (this.investmentDeposit.typePay !== consts.TYPE_SOCIO) {
      this.investmentDeposit.partnersId = 0;
    }

    if (this.investmentDeposit.typePay !== consts.TYPE_POLIZACREDITO) {
      this.investmentDeposit.polizaCreditoId = null;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.investmentFinancialService.depositCreate(this.investmentDeposit)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el pago");
          });
      }
      if (this.isEditMode === true) {
        this.investmentFinancialService.depositUpdate(this.investmentDeposit)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el pago");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }

  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;
    this.paided = false;

    this.invalidDate = false;
    this.invalidAmount = false;
    this.invalidTypePay = false;
    this.invalidBankAccount = false;
    this.invalidPaymentCard = false;

    let tempTotalInvestment: number = 0;
    if (this.investmentFinancial.investmentValue) {
      tempTotalInvestment = this.investmentFinancial.investmentValue;
    }

    this.investmentFinancialService.depositList(this.investmentFinancial.uid)
      .then(response => {
        this.dataSource = response;

        this.dataSource.forEach(deposit => {
          tempTotalInvestment -= deposit.amount;
        });

        if (this.dataSource.length > 0) {
          this.list = true;

          if (tempTotalInvestment === 0 || tempTotalInvestment <= 0) {
            this.paided = true;
          }
        }
        this.remaining = Utils.GetValueWithDecimals(tempTotalInvestment);
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public allocateRemaining(): void {
    if (this.isEditMode) {
      this.investmentDeposit.amount = Utils.GetValueWithDecimals((this.remaining + this.dataSource.find(f => f.uid == this.investmentDeposit.uid).amount));
    } else {
      this.investmentDeposit.amount = Utils.GetValueWithDecimals(this.remaining);
    }
  }

  public delete(uidInvestmentDeposit: string): void {
    // Este uid es el id
    this.investmentFinancialService.depositDelete(uidInvestmentDeposit)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el pago");
      });
  }

  public edit(uidInvestmentDeposit: string): void {
    const investmentDepositSearched = this.dataSource.find(f => f.uid == uidInvestmentDeposit);

    this.remaining = investmentDepositSearched.amount;
    this.paided = false;
    this.isEditMode = true;
    this.depositSaved = false;

    this.investmentDeposit = investmentDepositSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
